module.exports = "<ace-editor [(text)]=\"code\" mode=\"json\" style=\"height:400px;\" class=\"u-fancy-scrollbar scrollbar-telegram\"></ace-editor>"